'use client'

/* ---------------------------------
EventCard

TODO:
 Component should be
 promoted to AIRC UI kit
--------------------------------- */

import React, { CSSProperties, ReactElement } from 'react'
import {
  Button,
  Card,
  OpeningTitle,
  Paragraph,
  Tag,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import { NormalizedEventType } from '@/types/NormalizedEventType'
import { LuCalendarDays, LuMapPin } from 'react-icons/lu'
import classNames from 'classnames'
import Image from 'next/image'
import { dispatchGTMEvent } from '@/lib/tracking/gtm'
import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types/GTM_EVENT_CATEGORY'

type EventCardProps = {
  event: NormalizedEventType
  index?: number
}

export default function EventCard({
  event,
  index,
}: EventCardProps): ReactElement {
  const {
    title,
    description,
    startDate,
    endDate,
    region,
    location,
    imageUrl,
    imageAlt,
    ctaLabel,
    ctaUrl,
    tags,
  } = event

  const hasIndex = typeof index === 'number'

  return (
    <Card
      className='event-card'
      {...(hasIndex
        ? {
            animationDelay: index / 10,
            style:
              index % 2 === 0
                ? ({
                    '--card-bg': 'var(--airc-ui__colors-accent-100)',
                  } as CSSProperties)
                : {},
          }
        : {})}
    >
      <div className='event-card__content'>
        <header
          className={classNames(
            'event-card__content__header',
            imageUrl && 'event-card__content__header--with-image'
          )}
        >
          {imageUrl ? (
            <div className='event-card__content__header__image'>
              <Image
                fill
                style={{ objectFit: 'cover' }}
                sizes='80px'
                src={imageUrl}
                alt={imageAlt!}
              />
            </div>
          ) : null}

          <div>
            {region ? (
              <OpeningTitle
                alignment={'left'}
                className='event-card__content__header__region'
              >
                {region}
              </OpeningTitle>
            ) : null}

            {title ? (
              <Title
                as={'h6'}
                alignment={'left'}
                className='event-card__content__header__title'
              >
                {title}
              </Title>
            ) : null}
          </div>
        </header>

        {description ? (
          <div className='event-card__content__description'>
            <Paragraph alignment={'left'}>{description}</Paragraph>
          </div>
        ) : null}

        <div className='event-card__content__info'>
          {startDate && endDate ? (
            <span className='event-card__content__info__date'>
              <LuCalendarDays size={22} />

              <span>
                Dal <b>{startDate}</b> al <b>{endDate}</b>
              </span>
            </span>
          ) : null}

          {location ? (
            <span className='event-card__content__info__location'>
              <LuMapPin size={22} />

              <span>{location}</span>
            </span>
          ) : null}
        </div>

        {tags?.length ? (
          <div className='event-card__content__tags'>
            {tags!.map((tag) => {
              return (
                <Tag
                  key={tag.id}
                  className={'event-card__content__tags__tag'}
                >
                  {tag.tag}
                </Tag>
              )
            })}
          </div>
        ) : null}
      </div>

      <div className='event-card__actions'>
        {ctaUrl ? (
          <Button
            fullWidth
            animate={false}
            size={'small'}
            variant={'themed'}
            href={ctaUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClickCapture={() => {
              dispatchGTMEvent(GTM_EVENT_CATEGORY.EVENT_CLICKTHROUGH, {
                section: title,
              })
            }}
          >
            {ctaLabel || 'Maggiori informazioni'}
          </Button>
        ) : null}
      </div>
    </Card>
  )
}
